import React, { useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
  TypographyVariant,
} from '@mui/material';

interface IProps {
  open: boolean;
  title: string;
  children: React.ReactNode;
  onSave: Function;
  onCancel: Function;
  titleVariant?: TypographyVariant;
  maxWidth?: DialogProps['maxWidth'];
  disableSave?: boolean;
}

export const DialogStructure: React.FC<IProps> = ({
  open,
  title,
  children,
  onSave,
  onCancel,
  titleVariant = 'h4',
  maxWidth = 'lg',
  disableSave = false,
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  const onSaveClicked = () => {
    if (formRef.current && formRef.current.checkValidity()) {
      onSave();
    } else if (formRef.current && !formRef.current.checkValidity()) {
      const elements = Array.from(formRef.current.elements);

      elements.forEach((element: any) => {
        if (element.reportValidity()) {
          element.reportValidity();
        }
      });
    }
  };

  return (
    <Dialog open={open} maxWidth={maxWidth} fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant={titleVariant} component='div'>
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
          <form ref={formRef}>{children}</form>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Abbrechen</Button>
        <Button
          variant={'contained'}
          disabled={disableSave}
          onClick={onSaveClicked}
        >
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};
